<template lang="pug">
  .d-flex.align-center.justify-space-between(v-if="reward")
    .d-flex.align-center
      v-radio.ma-0(:value="reward" :disabled="disabled")
      .ml-4
        .text-sm.font-semibold(v-if="loyaltySystem === 'stamps'") {{ reward.name }}
        .text-sm.font-semibold(v-else) {{ reward.rebate_amount | displayPrice }} Rebate
    .d-flex.align-center
      .text-xs.danger500--text.mr-2(v-if="loyaltySystem === 'points' && disabled") Insufficient points
      y-chip.round-lg.py-1.px-2(:class="[disabled ? 'neutral200' : getEnabledChipColor]")
        .text-xs(:class="[disabled ? 'neutral700--text' : getEnabledTextColor]") {{ reward.eligibility }}
</template>

<script>
export default {
  props: {
    reward: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
    },
    loyaltySystem: {
      type: String,
      required: true
    }
  },
  computed: {
    getEnabledChipColor() {
      return this.loyaltySystem === 'stamps' ? 'success100' : 'warning100'
    },
    getEnabledTextColor() {
      return this.loyaltySystem === 'stamps' ? 'success500--text' : 'danger500--text'
    },
  },
}
</script>


<style scoped>

</style>